import saveAs from 'file-saver';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Link, withRouter } from 'react-router-dom';
import { truncate } from 'underscore.string';

import moment from 'moment';
import UploadFile from '../../../../components/Input/UploadFile';
import Searchbar from '../../../../components/Searchbar';

import placeholderImage from '../../../../assets/images/placeholder.jpg';
import SpringLoader from '../../../../components/SpringLoader/SpringLoader.js';
import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { config } from '../../../../config/index';
import { DELETE, GET, POST, PUT, newFetch } from '../../../../helpers/fetch';
import { getSelectedSiteIds } from '../../../../helpers/general';
import AppContext from '../../../../store/App/contexts';
const { API_URL, SERVER_URL } = config;

const AssociateManagement = ({ history }) => {
  const token = localStorage.getItem('token');
  const type = localStorage.getItem('type');
  const user = JSON.parse(localStorage.getItem('user'));
  const { selectedClientID, selectedSiteID } = React.useContext(AppContext);
  const clientID = parseInt(selectedClientID, 10);
  const siteID = parseInt(selectedSiteID, 10);
  const selectedSiteIDs = getSelectedSiteIds(clientID, siteID);
  const selectedSiteIDsKey = selectedSiteIDs.join(',');
  const user_client_id =
    user.site_supervisors && user.site_supervisors.length > 0
      ? user.site_supervisors[0].site.client_id
      : null;

  const [reasons, setReasons] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showAssignPointsModal, setShowAssignPointsModal] = useState(false);
  const [template] = useState(true);
  const [sortDescending, setSortDescending] = useState(false);
  const [sortName, setSortName] = useState(false);
  const [sortEmployee, setSortEmployee] = useState(false);
  const [sortDate, setSortDate] = useState(true);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [uploadClient, setUploadClient] = useState(
    type === 'supervisor' && user_client_id ? user_client_id : 0
  );

  const changeUploadClient = (e) => setUploadClient(e.target.value);

  const padding = 90; // adjust this to your needs
  let height = 525 + padding;
  let heightPx = height + 'px';
  let heightOffset = height / 2;
  let offsetPx = heightOffset + 'px';

  const style = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    border: '0',
    borderRadius: '20px',
    bottom: 'auto',
    maxHeight: heightPx, // set height
    left: '50%',
    padding: '2rem',
    position: 'fixed',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
    width: '50%',
    maxWidth: '50rem',
  };

  const [client, setClient] = useState([]);
  const [clients, setClients] = useState([]);
  const [sites, setSites] = useState([]);
  const [associates, setAssociates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clientFilters, setClientFilters] = useState([]);
  const [siteFilters, setSiteFilters] = useState([]);
  const [searchFilter, setSearchFilter] = useState('');
  const [filteredAssociates, setFilteredAssociates] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [showDeactivatedAssociate, setShowDeactivatedAssociate] =
    useState(false);

  const [points, setPoints] = useState(0);
  const [reason, setReason] = useState(0);
  const [remarks, setRemarks] = useState('');

  const downloadAssoc = async () => {
    let url = `${API_URL}/associate/export`;
    try {
      let data = {
        client_id: clientID,
        clients: [clientID],
        site_ids:
          siteFilters.length > 0
            ? siteFilters.filter((id) => selectedSiteIDs.includes(id))
            : selectedSiteIDs,
      };

      let response = await fetch(url, {
        method: 'POST',
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify(data),
      });

      const responseData = await response.json();
      if (response.ok) {
        const filename = `Associate_List.xlsx`;
        const buffer = responseData.data.buffer.data;
        const arraybuffer = Uint8Array.from(buffer).buffer;
        const blob = new Blob([arraybuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, filename);
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const checkboxHandler = (e) => {
    if (e.target.checked) {
      let updatedSelectedIds = [...selectedIds];

      updatedSelectedIds.push(parseInt(e.target.value));
      setSelectedIds(updatedSelectedIds);
    } else {
      let updatedSelectedIds = [...selectedIds].filter(
        (id) => id !== parseInt(e.target.value)
      );

      if (updatedSelectedIds.length === 0 && selectedAll === true) {
        setSelectedAll(false);
      }

      setSelectedIds(updatedSelectedIds);
    }
  };

  const checkboxAllOn = (e) => {
    if (e.target.checked) {
      let admin_ids = filteredAssociates
        .filter((admin) => showDeactivatedAssociate || admin.active)
        .map((admin) => admin.id);
      setSelectedIds(admin_ids);
      setSelectedAll(true);
    } else {
      setSelectedIds([]);
      setSelectedAll(false);
    }
  };

  const checkboxAllOff = (e) => {
    setSelectedIds([]);
    setSelectedAll(false);
  };

  const clientFilterCheckboxHandler = (e) => {
    const client_id = parseInt(e.target.value);
    if (e.target.checked) {
      if (![...clientFilters].some((id) => id === client_id)) {
        let filters = [...clientFilters];
        filters.push(client_id);
        setClientFilters(filters);
      }
    } else {
      const filtered = [...clientFilters].filter((id) => id !== client_id);
      setClientFilters(filtered);
    }
  };

  const clientFilterCheckboxAllHandler = (e) => {
    if (e.target.checked) {
      const clientIds = clients.map((client) => client.id);
      setClientFilters(clientIds);
    } else {
      setClientFilters([]);
    }
  };

  useEffect(() => {
    let newFilteredAssociates = JSON.parse(JSON.stringify(associates));

    if (clientFilters.length > 0) {
      newFilteredAssociates = newFilteredAssociates.filter((associate) =>
        clientFilters.some(
          (client_id) =>
            typeof associate.client !== 'undefined' &&
            client_id === associate.client.id
        )
      );
    }

    if (siteFilters.length > 0) {
      newFilteredAssociates = filterInput(newFilteredAssociates, siteFilters);
    }

    newFilteredAssociates = [...newFilteredAssociates].filter((associate) => {
      let name = `${associate.first_name} ${associate.last_name}`;
      return name.toUpperCase().indexOf(searchFilter.toUpperCase()) > -1;
    });

    if (sortName) {
      if (sortDescending) {
        newFilteredAssociates = newFilteredAssociates.sort((a, b) =>
          b.full_name.localeCompare(a.full_name)
        );
      } else {
        newFilteredAssociates = newFilteredAssociates.sort((a, b) =>
          a.full_name.localeCompare(b.full_name)
        );
      }
    }

    if (sortEmployee) {
      if (sortDescending) {
        newFilteredAssociates = newFilteredAssociates.sort((a, b) => {
          if (!a.employee_no) {
            return +1;
          }
          if (!b.employee_no) {
            return -1;
          }
          return b.employee_no.localeCompare(a.employee_no);
        });
      } else {
        newFilteredAssociates = newFilteredAssociates.sort((a, b) => {
          if (!a.employee_no) {
            return -1;
          }
          if (!b.employee_no) {
            return +1;
          }
          return a.employee_no.localeCompare(b.employee_no);
        });
      }
    }

    if (sortDate) {
      if (sortDescending) {
        newFilteredAssociates = newFilteredAssociates.sort((a, b) => {
          if (
            moment(a.updatedAt).toDate().getTime() <=
            moment(b.updatedAt).toDate().getTime()
          )
            return -1;
          else return +1;
        });
      } else {
        newFilteredAssociates = newFilteredAssociates.sort((a, b) => {
          if (
            moment(a.updatedAt).toDate().getTime() >
            moment(b.updatedAt).toDate().getTime()
          )
            return -1;
          else return +1;
        });
      }
    }

    setFilteredAssociates(newFilteredAssociates);
  }, [
    associates,
    clientFilters,
    siteFilters,
    searchFilter,
    sortDescending,
    sortName,
    sortEmployee,
    sortDate,
  ]);

  const siteFilterCheckboxHandler = (e) => {
    const site_id = parseInt(e.target.value);

    if (e.target.checked) {
      if (![...siteFilters].some((id) => id === site_id)) {
        let filters = [...siteFilters];
        filters.push(site_id);
        setSiteFilters(filters);
      }
    } else {
      const filtered = [...siteFilters].filter((id) => id !== site_id);
      setSiteFilters(filtered);
    }
  };

  const siteFilterCheckboxAllHandler = (e) => {
    if (e.target.checked) {
      const siteIds = sites.map((site) => site.id);
      setSiteFilters(siteIds);
    } else {
      setSiteFilters([]);
    }
  };

  const clearFilterHandler = () => {
    setClientFilters([]);
    setSiteFilters([]);
  };

  const filterInput = (input, filter) => {
    if (!Array.isArray(filter)) {
      filter = [filter];
    }

    let results = [];
    for (let i = 0; i < input.length; i++) {
      let sites = input[i].sites;
      for (let j = 0; j < sites.length; j++) {
        let id = sites[j].id;
        if (filter.includes(id)) {
          results.push(input[i]);
          break;
        }
      }
    }
    return results;
  };

  const searchHandler = (e) => {
    setSearchFilter(e.target.value);
  };

  const checkDefault = () => {
    return JSON.parse(reason).default_remarks;
  };

  useEffect(() => {
    if (checkDefault() != null) {
      setRemarks(checkDefault());
    } else {
      setRemarks('');
    }
  }, [reason]);

  const deleteAssociate = async (id) => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete this Associate?'
      )
    ) {
      try {
        let api_path = `/associate/${id}`;
        let response = await newFetch(DELETE, api_path);

        if (response.success) {
          ToastUtil.success(response.message);
          window.location.reload();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const deleteSelectedHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to delete these Associates?'
      )
    ) {
      const results = selectedIds.map(async (id) => {
        const url = `${API_URL}/associate/${id}`;

        let response = await fetch(url, {
          mode: 'cors',
          method: 'DELETE',
          withCredentials: true,
          headers: {
            Authorization: token,
          },
        });

        let data = await response.json();

        if (!response.ok) {
          console.log(response.statusText);
        }
      });

      Promise.all(results).then(() => {
        ToastUtil.error('Associates successfully deleted!');
        setTimeout(() => {
          window.location.reload();
        }, 800);
      });
    }
  };

  const deactivateAssociateHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to deactivate this associate?'
      )
    ) {
      const results = selectedIds.map(async (id) => {
        let api_path = `/associate/${id}/activation/deactivate`;
        let response = await newFetch(PUT, api_path);

        if (!response.success) {
          console.log(response.message);
        }
      });

      Promise.all(results).then((completed) => {
        ToastUtil.error('Associates successfully deactivated!');
        window.location.reload();
      });
    }
  };

  const fetchAssociates = async (clientID, siteIDs = selectedSiteIDs) => {
    if (!clientID || siteIDs.length === 0) {
      setAssociates([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      let api_path = `/associate/view_all/${clientID}?site_ids=${siteIDs.join(',')}`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let associates = response.data;

        setAssociates(associates);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const fetchClients = async () => {
    let url = `${API_URL}/client`;

    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let data = await response.json();

      if (response.ok) {
        const clientsData = data.data;

        setClients(clientsData);
      } else {
        ToastUtil.error('Failed to fetch clients!');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchClientById = async () => {
    setLoading(true);
    const api_path = `/client/${clientID}`;
    const response = await newFetch(GET, api_path);

    if (response.success) {
      const clientData = response.data;
      setClient(clientData);
    }
    setLoading(false);
  };

  const fetchSites = async () => {
    const url = `${API_URL}/sites`;
    try {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      let json = await response.json();

      if (response.ok) {
        setSites(json.data);
      } else {
        ToastUtil.error('Sites is not available');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReasons = async () => {
    let api_path = `/reward/reason`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setReasons(response.data);
    }
  };

  const arrayContainsArray = (superset, subset) => {
    if (0 === subset.length) {
      return false;
    }
    return subset.every(function (value) {
      return superset.indexOf(value) >= 0;
    });
  };

  const init = async () => {
    fetchAssociates(clientID, selectedSiteIDs);
    if (type !== 'supervisor') fetchClients();
    fetchSites();
    fetchReasons();
    fetchClientById();
  };

  const handleCloseAssignPointModal = () => {
    setPoints(0);
    setReason(0);
    setRemarks('');
    setShowAssignPointsModal(false);
  };

  const handleSubmitAsssignPoints = async (e) => {
    e.preventDefault();

    if (points <= 0) {
      ToastUtil.error('Please assign points!');
      return false;
    }

    if (selectedIds.length === 0) {
      ToastUtil.error('Please select associates!');
      return false;
    }

    if (reason == 0) {
      ToastUtil.error('Please select reason!');
      return false;
    }

    if (reason !== 0 && JSON.parse(reason).reason === 'Refund' && !remarks) {
      ToastUtil.error('Please enter remarks!');
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to assign points to the chosen associates?'
      )
    ) {
      try {
        setShowAssignPointsModal(false);

        let data = {
          points,
          associates: selectedIds,
          reason_id: JSON.parse(reason).id,
          remarks,
        };
        let api_path = `/reward/point`;
        let response = await newFetch(POST, api_path, data);

        if (response.success) {
          ToastUtil.success(response.message);
          window.location.reload();
        }
      } catch (err) {
        ToastUtil.error(err);
      }
    }
  };

  const sortNameAlphabetical = () => {
    if (!sortName) {
      setSortName(true);
      setSortEmployee(false);
      setSortDate(false);

      setSortDescending(false);
    } else {
      setSortDescending(!sortDescending);
    }
  };

  const sortEmployeeNo = () => {
    if (!sortEmployee) {
      setSortName(false);
      setSortEmployee(true);
      setSortDate(false);

      setSortDescending(false);
    } else {
      setSortDescending(!sortDescending);
    }
  };

  const sortDateModified = () => {
    if (!sortDate) {
      setSortName(false);
      setSortEmployee(false);
      setSortDate(true);

      setSortDescending(false);
    } else {
      setSortDescending(!sortDescending);
    }
  };

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (clientID !== null && clientID !== undefined) {
      // Allow 0 but not null/undefined
      checkboxAllOff();
      setClientFilters([parseInt(clientID)]);
      fetchAssociates(clientID, selectedSiteIDs);
      fetchClientById();
    }
  }, [clientID, selectedSiteIDsKey]);

  useEffect(() => {
    if (siteID !== null && siteID !== undefined) {
      setSiteFilters(selectedSiteIDs);
    }
  }, [siteID, selectedSiteIDsKey]);

  useEffect(() => {
    if (JSON.parse(reason)) {
      const parsed = JSON.parse(reason);
      setPoints(parsed.points);
    } else {
      setPoints(0);
    }
  }, [reason]);

  return (
    <div
      className="container-fluid"
      style={{
        paddingLeft: '2rem',
        paddingRight: '2rem',
        paddingBottom: '4rem',
      }}
    >
      <div className="border-bottom pb-3 py-4 d-flex justify-content-between align-items-center">
        <h6 className="flex-grow-1 module-title">Associate Management</h6>
        <div className="d-flex">
          {client?.enable_reward === true && (
            <button
              className="btn btn-brand ms-3 mt-2 adjust-shadow adjust-fs"
              style={{ width: '200px' }}
              type="button"
              disabled={selectedIds.length === 0}
              onClick={() => setShowAssignPointsModal(true)}
            >
              Assign Reward Points
            </button>
          )}
          <div className="dropdown custom-dropdown">
            <button
              className="btn btn-outline-brand ms-3 mt-2 dropdown-toggle adjust-shadow adjust-fs"
              style={{ width: '200px' }}
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-toggle="dropdown"
            >
              Add New
            </button>
            <div
              className="dropdown-menu mt-2"
              style={{ width: '200px' }}
              aria-labelledby="dropdownMenuButton"
            >
              <a
                className="dropdown-item border-bottom pb-2 adjust-fs"
                href="#"
                onClick={handleOpenModal}
              >
                Bulk Upload (.CSV)
              </a>
              <Link
                to="/associates/add"
                className="dropdown-item pt-2 adjust-fs"
              >
                Add New
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex flex-row align-items-center py-3">
        <h6 className="flex-grow-1">
          Associate (
          {
            filteredAssociates.filter((_associate) => {
              return showDeactivatedAssociate || _associate.active;
            }).length
          }
          )
        </h6>

        <div className="mb-2 pt-2 has-search me-3">
          <input
            id="include-inactive"
            className="form-check-input"
            type="checkbox"
            onChange={() => {
              setShowDeactivatedAssociate(!showDeactivatedAssociate);
            }}
          />
          <label
            className="text-muted fw-normal ms-2 adjust-fs"
            htmlFor="include-inactive"
            style={{
              cursor: 'pointer',
            }}
          >
            Include Inactive
          </label>
        </div>
        <Searchbar
          search={(e) => searchHandler(e)}
          placeholder="Search associate's name"
        />

        <div className="dropdown custom-dropdown">
          <button
            className="btn btn-brand ms-3 dropdown-toggle adjust-fs adjust-shadow"
            style={{ width: '100px' }}
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-toggle="dropdown"
          >
            <i className="fas fa-plus"></i> Filter
          </button>
          <button
            className="btn btn-brand ms-3 adjust-fs adjust-shadow"
            style={{ width: '100px' }}
            type="button"
            onClick={() => downloadAssoc()}
          >
            Export
          </button>
          <div
            className="dropdown-menu dropdown-menu-right mt-2"
            style={{ width: '500px' }}
            aria-labelledby="dropdownMenuButton"
          >
            <div className="container">
              {type !== 'supervisor' && (
                <React.Fragment>
                  <div className="d-flex flex-column pb-2">
                    <div className="pb-1">
                      <input
                        type="checkbox"
                        name="clientAll"
                        className="me-2"
                        checked={arrayContainsArray(
                          clients.map((client) => client.id),
                          clientFilters
                        )}
                        onChange={(e) => clientFilterCheckboxAllHandler(e)}
                      />{' '}
                      <strong className="text-muted adjust-fs">Clients</strong>
                    </div>
                    <div className="container">
                      {clients &&
                        clients.map((client) => (
                          <div className="d-flex" key={client.id}>
                            <label className="adjust-fs pb-2">
                              <input
                                type="checkbox"
                                value={client.id}
                                id={client.id}
                                name={`checkboxClient-${client.id}`}
                                className="me-2"
                                checked={clientFilters.some(
                                  (id) => id === client.id
                                )}
                                onChange={(e) => clientFilterCheckboxHandler(e)}
                                style={{
                                  cursor: 'pointer',
                                }}
                              />
                              {client.name}
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                </React.Fragment>
              )}
              {/* for sites filter */}
              <div className="d-flex flex-column pb-2">
                <div className="pb-1">
                  <input
                    type="checkbox"
                    name="siteAll"
                    className="me-2"
                    checked={arrayContainsArray(
                      sites.map((site) => site.id),
                      siteFilters
                    )}
                    onChange={(e) => siteFilterCheckboxAllHandler(e)}
                  />
                  <strong className="text-muted adjust-fs">Sites</strong>
                </div>
                <div
                  className="container"
                  style={{
                    height: 300,
                    overflowX: 'hidden',
                  }}
                >
                  {sites &&
                    sites
                      .filter((site) => site.active)
                      .map((site) => (
                        <div className="d-flex" key={site.id}>
                          <label className="adjust-fs pb-2">
                            <input
                              type="checkbox"
                              value={site.id}
                              name={`checkboxSite-${site.id}`}
                              className="me-2"
                              checked={siteFilters.some((id) => id === site.id)}
                              onChange={(e) => siteFilterCheckboxHandler(e)}
                              style={{
                                cursor: 'pointer',
                              }}
                            />
                            {site.name}
                          </label>
                        </div>
                      ))}
                </div>
              </div>
              <div className="d-flex justify-content-end border-top py-2">
                <div
                  className="text-muted fw-bold adjust-fs"
                  onClick={clearFilterHandler}
                  style={{ cursor: 'pointer' }}
                >
                  Clear
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table-responsive rounded shadow bg-white">
        <table className="table table-borderless mb-0">
          <thead className="border-bottom">
            <tr>
              <th className="py-3 text-muted fw-normal">
                <div className="form-check">
                  <input
                    className="form-check-input position-static"
                    onChange={checkboxAllOn}
                    type="checkbox"
                    checked={selectedAll}
                  />
                </div>
              </th>
              {selectedIds.length > 0 ? (
                <React.Fragment>
                  <th className="py-3 text-muted fw-normal adjust-fs">Name</th>
                  <th
                    className="py-3 text-muted fw-normal"
                    style={{ paddingRight: '130px' }}
                  ></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-muted fw-normal"></th>
                  <th className="py-3 text-danger fw-normal text-end">
                    <div
                      className="adjust-fs"
                      style={{ cursor: 'pointer', paddingRight: '10px' }}
                      onClick={deactivateAssociateHandler}
                    >
                      Deactivate
                    </div>
                  </th>
                  {/* {type === 'superadmin' && (
                    <th className="py-3 text-danger fw-normal">
                      <div
                        className="adjust-fs"
                        style={{ cursor: 'pointer' }}
                        onClick={deleteSelectedHandler}
                      >
                        Delete
                      </div>
                    </th>
                  )} */}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <th
                    className="py-3 text-muted fw-normal"
                    onClick={() => {
                      sortNameAlphabetical();
                    }}
                  >
                    <span className="adjust-fs" style={{ marginRight: 5 }}>
                      Name
                    </span>
                    {sortName ? (
                      sortDescending ? (
                        <i
                          className="fas fa-sort-alpha-up-alt ms-3"
                          style={{ fontSize: 20 }}
                        ></i>
                      ) : (
                        <i
                          className="fas fa-sort-alpha-down ms-3"
                          style={{ fontSize: 20 }}
                        ></i>
                      )
                    ) : (
                      <i
                        className="fas fa-sort ms-3"
                        style={{ fontSize: 20 }}
                      ></i>
                    )}
                  </th>
                  <th
                    className="py-3 text-muted fw-normal"
                    onClick={() => {
                      sortEmployeeNo();
                    }}
                  >
                    <span className="adjust-fs" style={{ marginRight: 5 }}>
                      Employee No.
                    </span>
                    {sortEmployee ? (
                      sortDescending ? (
                        <i
                          className="fas fa-sort-numeric-up-alt ms-3"
                          style={{ fontSize: 20 }}
                        ></i>
                      ) : (
                        <i
                          className="fas fa-sort-numeric-down ms-3"
                          style={{ fontSize: 20 }}
                        ></i>
                      )
                    ) : (
                      <i
                        className="fas fa-sort ms-3"
                        style={{ fontSize: 20 }}
                      ></i>
                    )}
                  </th>
                  <th className="py-3 text-muted fw-normal adjust-fs">Email</th>
                  <th className="py-3 text-muted fw-normal adjust-fs">
                    Client
                  </th>
                  <th className="py-3 text-muted fw-normal adjust-fs">Sites</th>
                  <th
                    className="py-3 text-muted fw-normal adjust-fs"
                    onClick={() => {
                      sortDateModified();
                    }}
                  >
                    <span className="adjust-fs" style={{ marginRight: 5 }}>
                      Date Modified
                    </span>
                    {sortDate ? (
                      sortDescending ? (
                        <i
                          className="fas fa-sort-amount-up-alt ms-3"
                          style={{ fontSize: 20 }}
                        ></i>
                      ) : (
                        <i
                          className="fas fa-sort-amount-down ms-3"
                          style={{ fontSize: 20 }}
                        ></i>
                      )
                    ) : (
                      <i
                        className="fas fa-sort ms-3"
                        style={{ fontSize: 20 }}
                      ></i>
                    )}
                  </th>
                  <th className="py-3 text-muted fw-normal adjust-fs"></th>
                </React.Fragment>
              )}
            </tr>
          </thead>
          <tbody>
            {filteredAssociates.length > 0 ? (
              filteredAssociates.map((associate) => (
                <tr
                  key={associate.id}
                  className="border-bottom"
                  style={
                    !associate.active && !showDeactivatedAssociate
                      ? { display: 'none' }
                      : filteredAssociates.length === 1
                      ? { height: '150px' }
                      : {}
                  }
                >
                  <td style={{ paddingTop: '30px' }}>
                    <div className="form-check">
                      <input
                        className="form-check-input position-static"
                        type="checkbox"
                        checked={selectedIds.some((id) => id === associate.id)}
                        value={associate.id}
                        onChange={checkboxHandler}
                      />
                    </div>
                  </td>
                  <td className="d-flex align-items-center">
                    <img
                      src={
                        associate.image
                          ? `${SERVER_URL}/${associate.image}`
                          : placeholderImage
                      }
                      alt="No image available"
                      className="rounded-circle border me-3"
                      style={{ height: '60px', width: '60px' }}
                    />
                    <Link
                      to={`/associates/associate/${associate.id}`}
                      style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                      <strong
                        className={
                          !associate.active ? 'text-danger' : 'text-muted'
                        }
                      >{`${associate.full_name}`}</strong>
                    </Link>
                  </td>
                  <td className="text-muted" style={{ paddingTop: '30px' }}>
                    {associate.employee_no}
                  </td>
                  <td className="text-muted" style={{ paddingTop: '30px' }}>
                    {associate.email}
                  </td>
                  <td
                    data-toggle="tooltip"
                    data-placement="top"
                    title={associate.client ? associate.client.name : '-'}
                    className="text-muted"
                    style={{ paddingTop: '30px' }}
                  >
                    {associate.client
                      ? truncate(associate.client.name, 12)
                      : '-'}
                  </td>
                  <td style={{ paddingTop: '30px' }}>
                    <div className="d-flex flex-row align-items-center">
                      {associate.sites && associate.sites.length > 2
                        ? associate.sites.slice(0, 2).map((site, index) => (
                            <>
                              <span
                                key={site.id}
                                className="badge rounded-pill bg-brand text-white me-1"
                                style={{ width: '50px' }}
                              >
                                {site.name}
                              </span>
                              <br />
                              <span>
                                {site.is_team_support
                                  ? 'Fixed Schedule'
                                  : 'Flexi'}
                              </span>
                            </>
                          ))
                        : associate.sites.map((site, index) => (
                            <React.Fragment key={`${site}-${index}`}>
                              <span
                                key={site.id}
                                className="badge rounded-pill bg-brand text-white me-1"
                              >
                                {site.name}
                              </span>
                              <br />
                              <span
                                className="badge rounded-pill bg-secondary text-white me-1"
                                style={{ width: '100px' }}
                              >
                                {site.is_team_support
                                  ? 'Fixed Shift'
                                  : 'Flexi Shift'}
                              </span>
                            </React.Fragment>
                          ))}
                      {associate.sites.length > 2 && (
                        <div className="fw-bold text-brand">
                          <div
                            style={{ cursor: 'pointer' }}
                            data-toggle="dropdown"
                          >
                            +{associate.sites.length - 2}
                          </div>
                          <div
                            className="dropdown-menu dropdown-menu-right"
                            style={{ width: '150px' }}
                          >
                            <div className="container">
                              {associate.sites
                                .slice(
                                  associate.sites.length - 1,
                                  associate.sites.length
                                )
                                .map((site) => (
                                  <span
                                    key={site.id}
                                    className="badge rounded-pill bg-brand text-white me-1"
                                  >
                                    {site.name}
                                  </span>
                                ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="text-muted" style={{ paddingTop: '30px' }}>
                    {moment(associate.updatedAt).format('D/M/YYYY hh:mm a')}
                  </td>
                  <td
                    className="text-center align-items-center"
                    style={{ paddingTop: '20px' }}
                  >
                    <div
                      style={{ cursor: 'pointer' }}
                      className="dropdown custom-dropdown"
                    >
                      <button
                        className="btn dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i
                          className="fas fa-ellipsis-h adjust-fs"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        ></i>
                      </button>
                      <div
                        className="dropdown-menu dropdown-menu-right"
                        style={{ width: '150px' }}
                      >
                        <Link
                          to={`/associates/associate/${associate.id}/edit`}
                          style={{ cursor: 'pointer' }}
                          className="dropdown-item pb-2 adjust-fs"
                        >
                          Edit
                        </Link>
                        {/* {type === 'superadmin' && (
                          <div
                            onClick={() => deleteAssociate(associate.id)}
                            style={{ cursor: 'pointer' }}
                            className="dropdown-item border-top pt-2 adjust-fs"
                          >
                            Delete
                          </div>
                        )} */}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  {loading ? (
                    <div className="springloader-holder">
                      <SpringLoader></SpringLoader>
                    </div>
                  ) : (
                    <div className="text-center text-muted my-3 pb-4">
                      <i>No results</i>
                    </div>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={showModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: style,
        }}
      >
        <h6 className="flex-grow-1">Upload New Associates</h6>
        {type !== 'supervisor' && (
          <div className="py-3 d-flex flex-column">
            <span>Client: </span>
            <select
              className="form-select mt-2 adjust-fs"
              value={uploadClient}
              onChange={(e) => changeUploadClient(e)}
            >
              <option value={0}>Choose Client</option>
              {clients &&
                clients.map((client) => (
                  <option key={client.id} value={client.id}>
                    {client.name}
                  </option>
                ))}
            </select>
          </div>
        )}

        {parseInt(uploadClient) > 0 && (
          <React.Fragment>
            <p className="text-muted">Drag and drop your file here</p>
            <UploadFile
              url={`${API_URL}/client/${uploadClient}/associate/import`}
              handleCloseModal={handleCloseModal}
              template={'templates/associate_template.csv'}
            />
          </React.Fragment>
        )}
      </Modal>
      <Modal
        ariaHideApp={false}
        isOpen={showAssignPointsModal}
        style={{
          overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
          content: style,
        }}
      >
        <div className="h-100">
          <form
            className="d-flex flex-column justify-content-between flex-grow-1 h-100"
            onSubmit={(e) => handleSubmitAsssignPoints(e)}
          >
            <h6 className="flex-grow-1">Assign Reward Points</h6>
            <div className="mb-2">
              <label htmlFor="assignPoints">Points</label>
              <input
                type="number"
                min="0"
                className="form-control w-auto border my-2 adjust-fs"
                id="assignPoints"
                placeholder="Reward Points"
                value={
                  JSON.parse(reason).points > 0
                    ? JSON.parse(reason).points
                    : points
                }
                disabled={JSON.parse(reason).points > 0}
                onChange={(e) => setPoints(e.target.value)}
              />
            </div>
            <div className="mb-2">
              <label htmlFor="assignReason">Reason</label>
              <select
                name="assignPointReason"
                id="assignPointReason"
                className="form-select w-50 border my-2 adjust-fs"
                value={reason}
                onChange={({ target: { value } }) => setReason(value)}
              >
                <option value="0">Choose Reason</option>
                {reasons.length > 0 &&
                  reasons.map(
                    (reason) =>
                      reason.active && (
                        <option key={reason.id} value={JSON.stringify(reason)}>
                          {reason.reason}
                        </option>
                      )
                  )}
              </select>
            </div>
            <div className="mb-2">
              <label htmlFor="assignRemarks">Remarks</label>
              <textarea
                rows="5"
                style={{ resize: 'none' }}
                className="form-control my-2 adjust-fs"
                id="assignRemarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
              />
            </div>
            <h6 className="flex-grow-1">
              Selected Associates ({selectedIds.length})
            </h6>
            <div className="py-3">
              <table className="table table-bordered table-striped mb-0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Employee No.</th>
                  </tr>
                </thead>
                <tbody>
                  {JSON.parse(JSON.stringify([...filteredAssociates]))
                    .filter((associate) => selectedIds.includes(associate.id))
                    .map((associate) => (
                      <tr key={associate.id}>
                        <td>{`${associate.full_name}`}</td>
                        <td>{`${associate.employee_no}`}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-end mt-auto pt-3 pb-3 border-top">
              <button
                type="button"
                onClick={handleCloseAssignPointModal}
                className="btn btn-outline-brand adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Assign
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default withRouter(AssociateManagement);
